import { motion } from "framer-motion";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function Reveal({ children, delay = 0, className, as = "div", ...rest }) {
  const Comp = motion[as];
  return (
    <Comp className={className} initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-6% 0px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }} {...rest}>
      {children}
    </Comp>
  );
}

export function DataTip({ label, children }) {
  return (
    <Tooltip delayDuration={80}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent className="rounded-xl border border-white/10 bg-[#0E2412] px-3 py-2 font-ui text-[12px] text-white shadow-xl">{label}</TooltipContent>
    </Tooltip>
  );
}
